// extracted by mini-css-extract-plugin
export default {"block":"Counter_block__ySbXK","readonly":"Counter_readonly__kFiP6","count":"Counter_count__bZFJv","icon":"Counter_icon__ItPBg","disabled":"Counter_disabled__4z8JL"};